import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';

const Menu = () => {
  const { themeConfig } = useTheme();
  const { menu } = themeConfig;

  return (
    <section id="menu" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="uppercase tracking-[0.25em] text-gold-accent text-sm mb-3">
            A taste of La Vie
          </p>
          <h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-4">
            {menu.title}
          </h2>
          <p className="text-lg text-warm-brown/70 max-w-2xl mx-auto">
            {menu.subtitle}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {menu.categories.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="bg-cream rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="relative h-48">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-warm-brown/30 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-playfair text-warm-brown mb-2">
                  {category.title}
                </h3>
                <p className="text-warm-brown/70 mb-4 italic">
                  {category.subtitle}
                </p>
                <ul className="space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-warm-brown/80 flex items-center">
                      <span className="w-2 h-2 bg-gold-accent rounded-full mr-3" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;